import { Order } from '@/data/mockData';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface ConfirmDeliveryDialogProps {
  order: Order | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: (order: Order) => void;
}

export const ConfirmDeliveryDialog = ({
  order,
  onOpenChange,
  onConfirm,
}: ConfirmDeliveryDialogProps) => {
  const handleConfirm = () => {
    if (order) {
      onConfirm(order);
    }
  };

  return (
    <AlertDialog open={!!order} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirmer la livraison</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <div className="text-base font-semibold text-foreground">
              Récapitulatif de votre commande:
            </div>
            <div className="bg-muted/50 p-4 rounded-lg space-y-2">
              <div className="flex justify-between">
                <span className="font-medium">Volume :</span>
                <span>
                  {order?.volume.toLocaleString('fr-FR')}{' '}
                  {order?.type === 'Email' ? 'Emails' : order?.type === 'Mobile' ? 'Mobiles' : 'CRM IDs'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Montant H.T. :</span>
                <span className="font-bold text-success">{order && Math.ceil(order.price).toLocaleString('fr-FR')} €</span>
              </div>
            </div>
            <div className="text-sm text-foreground font-medium pt-2">
              ⚠️ La confirmation de cette demande entraîne la validation immédiate du devis.
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirm}
            className="bg-primary hover:bg-primary-hover"
          >
            Confirmer
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

